import React from 'react';
export const PlaceholderReactMessageTemplateImage = (props) => {
    return React.createElement("div", { style: Object.assign(Object.assign({}, props.style), { backgroundColor: 'transparent' }) });
};
